var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteBlackIco = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05A93240-EE2D-4475-9354-5225B5476DE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7.1.0.1-Onboarding---Position---New-Position",
    transform: "translate(-260.000000, -661.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(260.000000, 661.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8836846,4.35744681 L15.3879781,4.35744681 L15.3879781,1.0893617 C15.3879781,0.487723847 14.8958758,0 14.2888368,0 L7.69398907,0 C7.0869501,0 6.59484778,0.487723847 6.59484778,1.0893617 L6.59484778,4.35744681 L1.0991413,4.35744681 C0.49210232,4.35744681 0,4.84517066 0,5.44680851 C0,6.04844637 0.49210232,6.53617021 1.0991413,6.53617021 L2.19828259,6.53617021 L2.19828259,22.8765957 C2.19828259,23.4782336 2.69038491,23.9659574 3.29742389,23.9659574 L18.685402,23.9659574 C19.292441,23.9659574 19.7845433,23.4782336 19.7845433,22.8765957 L19.7845433,6.53617021 L20.8836846,6.53617021 C21.4907236,6.53617021 21.9828259,6.04844637 21.9828259,5.44680851 C21.9828259,4.84517066 21.4907236,4.35744681 20.8836846,4.35744681 Z M8.79313037,2.1787234 L13.1896956,2.1787234 L13.1896956,4.35744681 L8.79313037,4.35744681 L8.79313037,2.1787234 Z M17.5862607,21.787234 L4.39656518,21.787234 L4.39656518,6.53617021 L17.5862607,6.53617021 L17.5862607,21.787234 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.991413,8.71489362 C10.384374,8.71489362 9.89227166,9.20261746 9.89227166,9.80425532 L9.89227166,18.5191489 C9.89227166,19.1207868 10.384374,19.6085106 10.991413,19.6085106 C11.5984519,19.6085106 12.0905543,19.1207868 12.0905543,18.5191489 L12.0905543,9.80425532 C12.0905543,9.20261746 11.5984519,8.71489362 10.991413,8.71489362 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69398907,9.80425532 C7.0869501,9.80425532 6.59484778,10.2919792 6.59484778,10.893617 L6.59484778,17.4297872 C6.59484778,18.0314251 7.0869501,18.5191489 7.69398907,18.5191489 C8.30102805,18.5191489 8.79313037,18.0314251 8.79313037,17.4297872 L8.79313037,10.893617 C8.79313037,10.2919792 8.30102805,9.80425532 7.69398907,9.80425532 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1896956,10.893617 L13.1896956,17.4297872 C13.1896956,18.0314251 13.6817979,18.5191489 14.2888368,18.5191489 C14.8958758,18.5191489 15.3879781,18.0314251 15.3879781,17.4297872 L15.3879781,10.893617 C15.3879781,10.2919792 14.8958758,9.80425532 14.2888368,9.80425532 C13.6817979,9.80425532 13.1896956,10.2919792 13.1896956,10.893617 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteBlackIco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteBlackIco.6f35306f06eb55062639eb080627b674.svg";